import API from "@/services/api";
import { 
  CheckDiffIBANAPIParams,
  IBANsFetchSucessResponse,
  ICheckDiffIBANParams,
  ICheckDiffIBANSucessResponse,
  IIBANChangeSucessResponse, 
  ISendIBANChangeParams, 
  SendIBANChangeAPIParams 
} from "../types/iban";

export enum EndpointName {
  ChangeIBAN = '/contracts/:contractName/iban/',
  checkDiffIBAN = '/contracts/:contractName/iban/check/',
  FetchIBANs = '/ibans/'
}

const fetchIBANs = () => {
  return API.get<IBANsFetchSucessResponse>({
    endpoint: EndpointName.FetchIBANs
  });
}

const sendIBANChange = ({
  contractName,
  type = "electricity",
  value
}: ISendIBANChangeParams) => {

  const data = value.alreadyRegistered === 'yes' ? {
    already_registered: value.alreadyRegistered,
    bank_id: value.bankId,
    files: value.files
  } : {
    already_registered: value.alreadyRegistered,
    iban: value.iban,
    owner_is_bank_owner: value.isOwner,
    files: value.files
  }

  if (type === "gas") {
    return API.post<IIBANChangeSucessResponse, SendIBANChangeAPIParams>({
      versions: [2],
      endpoint: EndpointName.ChangeIBAN,
      data,
      params: {
        contractName
      }
    });
  }
  return API.post<IIBANChangeSucessResponse, SendIBANChangeAPIParams>({
    endpoint: EndpointName.ChangeIBAN,
    data,
    params: {
      contractName
    }
  });
}

const checkDiffIBAN = ({
  contractName,
  type = "electricity",
  iban
}: ICheckDiffIBANParams) => {

  const data = {
    iban,
    type
  }

  return API.post<ICheckDiffIBANSucessResponse, CheckDiffIBANAPIParams>({
    versions: [2],
    endpoint: EndpointName.checkDiffIBAN,
    data,
    params: {
      contractName
    }
  });
}

export default {
  checkDiffIBAN,
  sendIBANChange,
  fetchIBANs
};